/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `free` - Free
 * * `trial` - Trial
 * * `paid` - Paid
 * @export
 */
export const SubscriptionTypeEnum = {
    Free: 'free',
    Trial: 'trial',
    Paid: 'paid'
} as const;
export type SubscriptionTypeEnum = typeof SubscriptionTypeEnum[keyof typeof SubscriptionTypeEnum];


export function instanceOfSubscriptionTypeEnum(value: any): boolean {
    for (const key in SubscriptionTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(SubscriptionTypeEnum, key)) {
            if (SubscriptionTypeEnum[key as keyof typeof SubscriptionTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubscriptionTypeEnumFromJSON(json: any): SubscriptionTypeEnum {
    return SubscriptionTypeEnumFromJSONTyped(json, false);
}

export function SubscriptionTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionTypeEnum {
    return json as SubscriptionTypeEnum;
}

export function SubscriptionTypeEnumToJSON(value?: SubscriptionTypeEnum | null): any {
    return value as any;
}

export function SubscriptionTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): SubscriptionTypeEnum {
    return value as SubscriptionTypeEnum;
}

